  import { Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';
  import {  ViewChild, ViewEncapsulation } from "@angular/core";
  import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
  import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
  import { ApiService } from 'app/shared/services/api.service';
  import { NgxSpinnerService } from 'ngx-spinner';
  import { ToastrService } from 'ngx-toastr';
  import swal from 'sweetalert2';
  import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
 
  
  @Component({
    selector: 'app-discount-list',
    templateUrl: './discount-list.component.html',
    styleUrls: ['./discount-list.component.scss', "../../../../../../assets/sass/libs/datatables.scss"],
    encapsulation: ViewEncapsulation.None,
  })
  export class DiscountListComponent implements OnInit {
    @ViewChild(DatatableComponent) table: DatatableComponent;
    page = {
      pageNumber:0,
      offset: 0,
      pageSize: 100,
      totalPages:0
    };
    // row data
    public rows = [];
    public filterRows=[];
    public ColumnMode = ColumnMode;
    public limitRef = 100;
    selectedValue=''
    isFilter:boolean=false
    public columns = [
      { name: "Name", prop: "name" },
      { name:"Discount Type",prop:"discount_type"},
      { name: "Amount", prop: "amount" },
      { name: "Actions", prop: "Actions" },
    ];
  
    // private
    private tempData = []; 
  
    tag_id:any
    searchVal:any;
    @ViewChild('name') inputName
    user_role:any

    guideline_data:any
  
    constructor( public apiService:ApiService,
                 private modalService: NgbModal,
                 public toastr: ToastrService ,
                 private spinner: NgxSpinnerService) { 
                this.user_role = JSON.parse(localStorage.getItem('user'))
                let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'Discounts') 
                this.guideline_data = key_data[0]?._id
                  }
  
    ngOnInit(): void {this.getAllDiscount()
    }
   
    getAllDiscount(){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.apiService.getAllDiscounts(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
      this.spinner.hide();
        this.rows=res.data.items
        this.page.totalPages=res.data.totalCount
      })
    }
    pageChangeData(page:any){
      this.apiService.getAllDiscounts(page.offset +1,page.pageSize).subscribe((res:any)=>{
        this.rows=res.data.items
        this.page.totalPages=res.data.totalCount
    
      })
    }
    getTagsFilter(data:any){
      let search=data
      if(search){
        this.apiService.getTagSearch(search).subscribe((res:any)=>{
          this.rows=res.data
        })
      }
      else{
        this.getAllDiscount()
      }
    }
    resetFilter(){
      this.inputName.nativeElement.value=''
      this.getAllDiscount()
    }
    editTag(id:any){
    }
    deleteDiscount(){
      if(this.tag_id){
        this.apiService.deleteDiscount(this.tag_id).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.getAllDiscount()
          
          }
          else{
            this.toastr.error(res.error)
          } 
          })
      }
      else{
        this.toastr.error('something went wrong !!')
      }
    }
     // ================== Delete Alert ========================
     ConfirmColor(id:any) {
      this.tag_id=id
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2F8BE6',
        cancelButtonColor: '#F55252',
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-warning',
          cancelButton: 'btn btn-danger ml-1'
        },
        buttonsStyling: false,
      }).then( (result)=> {
        if (result.value) {  
          this.deleteDiscount()      
          swal.fire({
            icon: "success",
            title: 'Deleted!',
            text: 'Your imaginary file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your imaginary file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }
    
    // ==========================================
     // Public Methods
    // -----------------------------------------------------------------------------------------------------
  
    /**
     * filterUpdate
     *
     * @param event
     */
     filterUpdate(event) {
      const val = event.target.value.toLowerCase();
  
      // filter our data
      const temp = this.tempData.filter(function (d) {
        return d.Username.toLowerCase().indexOf(val) !== -1 || !val;
      });
  
      // update the rows
      this.rows = temp;
      this.filterRows=temp
      // Whenever the filter changes, always go back to the first page
      this.table.offset = 0;
    }
  
    /**
     * updateLimit
     *
     * @param limit
     */
    updateLimit(limit) {
      this.limitRef = limit.target.value;
      this.apiService.getAllDiscounts(1,this.limitRef).subscribe((res:any)=>{
        this.rows=res.data.items
      })
    }
    openDynamicModal(key_id:string) {
      const modalOptions: NgbModalOptions = {
        size: 'lg', // 'sm', 'lg', or 'xl'
        backdrop: 'static',
      };
      const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
      modalRef.componentInstance.key_id = key_id;
    }
  }
  
